import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

export const getProgressReportSubprojectClose = (
  period = 0,
  projectCode = null,
  projectVersionId = null,
  installmentPlanId
) => {
  // http://localhost/api/subproject/subproject-progress-report/page/2?period=1&projectVersionId=3&projectCode=4
  const url = `${API_ROOT}/subproject/subproject-progress-report/page/${installmentPlanId}?period=${period}&projectCode=${projectCode}&projectVersionId=${projectVersionId}`

  return doGet(url)
}

export const saveProgressReportSubprojectClose = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-introduction`
  return doPost(url, request)
}

export const saveObjective = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-objective`
  return doPost(url, request)
}

export const saveActivitiesresult = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-activitiesresult`
  return doPost(url, request)
}

export const saveActivitiescost = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-activitiescost`
  return doPost(url, request)
}

//บันทึกความก้าวหน้า
export const saveProgress = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-progress`
  return doPost(url, request)
}

//บันทึกแกนนำในด้านการสร้างเสริมสุขภาพในประเด็นต่างๆ
export const saveLeaders = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-leaders`
  return doPost(url, request)
}

//3.1 บันทึกจำนวนผู้ได้รับผลประโยชน์จากโครงการนี้
export const saveBeneficiary = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-beneficiary`
  return doPost(url, request)
}

//3.2 บันทึกสภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาพ
export const saveSocialfactors = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-socialfactors`
  return doPost(url, request)
}

//3.3 นวัตกรรมสร้างเสริมสุขภาพ
export const saveInnovations = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-innovations`
  return doPost(url, request)
}

//3.4 บันทึกโครงการตัวอย่างที่ดี
export const saveBestpractice = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-bestpractice`
  return doPost(url, request)
}

export const saveActivitiesImage = (request) => {
  // http://103.91.191.229:9000/api/subproject/subproject-progress-report/save-activitiesimage
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-activitiesimage`
  return doPostFiles(url, request)
}

// 4. ปัญหา อุปสรรค และความเสี่ยง
export const saveProgressRisk = (request) => {
  const url = `${API_ROOT}/subproject/subproject-progress-report/save-progress-risk`
  return doPost(url, request)
}

// โหลดไฟล์
export const downloadFileSubproject = (pathFile) => {
  const url = `${API_ROOT}/subproject/download/file?filePath=${pathFile}`
  return doDownload(url)
}
